import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { map } from 'rxjs';
import {
  collectPageI18nPaths,
  TranslocoPageRouteSyncService,
} from '../transloco/transloco-loader';

function getLeafRouteSnapshot(
  root: ActivatedRouteSnapshot
): ActivatedRouteSnapshot {
  let route = root;
  while (route.firstChild) {
    route = route.firstChild;
  }
  return route;
}

/**
 * Loads page-scoped i18n bundles before the route component renders.
 * Declare extra bundles on the route via `data.pageI18n` when the URL path
 * does not match the bundle path (e.g. dashboard, inventory reception).
 *
 * Model field labels for tables/modals are loaded separately when those
 * components open — see {@link ModelTranslationService.setActiveModel}.
 */
export const pageI18nResolver: ResolveFn<void> = (_route, state) => {
  const leaf = getLeafRouteSnapshot(state.root);
  return inject(TranslocoPageRouteSyncService)
    .ensurePageTranslationsForUrl(
      state.url,
      collectPageI18nPaths(leaf),
      leaf
    )
    .pipe(map(() => undefined));
};